import { defineMessages } from 'react-intl';

export default defineMessages({
    addressLookUpOverride: {
        id: 'address-lookup-component.Override',
        defaultMessage: 'Override'
    },
    addressLookupAddressLine1:{
        id: 'address-lookup-component.AddressLine1',
        defaultMessage: 'Address Line 1' 
    },
    addressLookupAddressLine2:{
        id: 'address-lookup-component.AddressLine2',
        defaultMessage: 'Address Line 2' 
    },
    addressLookupAddressLine3:{
        id: 'address-lookup-component.AddressLine3',
        defaultMessage: 'Address Line 3' 
    },
    addressLookupCity:{
        id: 'address-lookup-component.City',
        defaultMessage: 'City' 
    },
    addressLookupState:{
        id: 'address-lookup-component.Province',
        defaultMessage: 'Province' 
    },
    addressLookupCountry:{
        id: 'address-lookup-component.Country',
        defaultMessage: 'Country' 
    },
    addressLookupPostalCode:{
        id: 'address-lookup-component.PostalCode',
        defaultMessage: 'Postal Code' 
    },
    addressLookupAddressType:{
        id: 'address-lookup-component.MailingAddress',
        defaultMessage: 'Mailing Address' 
    },
    addAddressButton:{
        id: 'address-lookup-component.Add',
        defaultMessage: 'Add' 
    },
    saveAddressButton:{
        id: 'address-lookup-component.Save',
        defaultMessage: 'Save' 
    },
    cancelAddressButton:{
        id: 'address-lookup-component.Cancel',
        defaultMessage: 'Cancel' 
    }
});
